import { Typography, ContentDisplay, Box } from '../../base';
import {
    PageContainer,
    Header,
    Content,
    PDFWrapper,
    LogoImage,
    HeaderContent,
} from './PrivacyPolicyPage.styles';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LANGUAGES } from '../../common';
import privacyEnglish from '../../../public/assets/pargoda_privacy_english.html?raw';
import privacyHebrew from '../../../public/assets/pargoda_privacy_hebrew.html?raw';

const PrivacyPolicyPage = () => {
    const [searchParams] = useSearchParams();

    const { htmlContent, isRTL } = useMemo(() => {
        // Check for lan query parameter (case-insensitive)
        const language = searchParams.get('lan')?.toLowerCase();
        const isHebrew = language === LANGUAGES.HE.toLowerCase();

        // Load the appropriate HTML content
        const content = isHebrew ? privacyHebrew : privacyEnglish;

        return {
            htmlContent: content,
            isRTL: isHebrew,
        };
    }, [searchParams]);

    const pageTitle = isRTL
        ? 'מדיניות פרטיות - PARGODA'
        : 'Privacy Policy - Pargoda';

    return (
        <Box dir={isRTL ? 'rtl' : 'ltr'}>
            <PageContainer>
                <Header>
                    <LogoImage
                        src="/assets/fullTextLogo.svg"
                        alt="Pargoda Logo"
                    />
                    <HeaderContent>
                        <Typography variant="h4" component="h1">
                            {pageTitle}
                        </Typography>
                    </HeaderContent>
                </Header>
                <Content>
                    <PDFWrapper>
                        <ContentDisplay content={htmlContent} />
                    </PDFWrapper>
                </Content>
            </PageContainer>
        </Box>
    );
};

export default PrivacyPolicyPage;
